module.exports = __webpack_public_path__ + "static/img/home-profile-bg.d34bf539.png";